// extracted by mini-css-extract-plugin
module.exports = {"body":"body__wh-9A","body-inner":"body-inner__3htBj"};